import { render, staticRenderFns } from "./TripDetailsScreen.vue?vue&type=template&id=ed0c4488&scoped=true"
import script from "./TripDetailsScreen.vue?vue&type=script&lang=js"
export * from "./TripDetailsScreen.vue?vue&type=script&lang=js"
import style0 from "./TripDetailsScreen.vue?vue&type=style&index=0&id=ed0c4488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0c4488",
  null
  
)

export default component.exports